import { render } from "./scatter-map.vue?vue&type=template&id=6ef5fd39&scoped=true"
import script from "./scatter-map.vue?vue&type=script&lang=js"
export * from "./scatter-map.vue?vue&type=script&lang=js"

import "./scatter-map.vue?vue&type=style&index=0&id=6ef5fd39&lang=less&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef5fd39"]])

export default __exports__